import { type ErrorComponentProps, useRouter } from '@tanstack/react-router'
import type { ReactElement } from 'react'

import { ApiError } from '@/lib/api'

import { ErrorState } from './error-state'

/**
 * ErrorBoundary de rota. É o que o TanStack Router renderiza quando o
 * carregamento ou a renderização de uma rota estoura — nunca deixamos a tela
 * branca (DoD).
 *
 * "Tentar de novo" limpa o boundary e refaz os loaders da rota atual.
 */
export function RouteErrorBoundary({ error, reset }: ErrorComponentProps): ReactElement {
  const router = useRouter()

  const traceId = ApiError.is(error) ? error.traceId : undefined
  const titulo =
    ApiError.is(error) && error.isNetworkError
      ? 'Sem conexão com o servidor'
      : 'Algo deu errado nesta tela'

  return (
    <div className="mx-auto w-full max-w-2xl p-6">
      <ErrorState
        titulo={titulo}
        erro={error}
        {...(traceId === undefined ? {} : { traceId })}
        aoTentarNovamente={() => {
          reset()
          void router.invalidate()
        }}
      />
    </div>
  )
}
